import React from 'react';
import {Link} from 'react-router-dom';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import styles from './CreatorNameLink.module.scss';

type BodySize = 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface CreatorNameLinkProps {
  testID?: string;
  name: string;
  link?: string;
  size?: BodySize;
  onClick?: (e: React.MouseEvent) => void;
}

function CreatorNameLink({
  testID = 'creator-name-link',
  name,
  link,
  size = 'md',
  onClick,
}: CreatorNameLinkProps) {
  if (!link) {
    return (
      <Body
        data-testid={testID}
        size={size}
        color={designSystemToken('semantic.fg.primary')}
      >
        {name}
      </Body>
    );
  }

  return (
    <Link
      to={{search: link}}
      replace
      className={styles.link}
      data-testid={testID}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
    >
      <Body size={size} color={designSystemToken('semantic.fg.primary')}>
        {name}
      </Body>
    </Link>
  );
}

export default CreatorNameLink;
